import { createElement } from 'react';
import { FloraTypography } from '@grupoboticario/flora-react';
import { ButtonIcon, Icon } from 'ui/components/primitives';
import { DrawerHeader } from './Drawer.components.styles';
import { isMobile } from 'core/use-cases/app/helpers';
import type { DrawerHeaderProps } from './Drawer.components.d';

const DrawerHeaderBase = ({ children, headerIcon, onDismiss, ...props }: DrawerHeaderProps) => {
  const icon = Icon[headerIcon as keyof typeof Icon];

  return (
    <DrawerHeader.Component {...props}>
      <ButtonIcon onClick={onDismiss}>{createElement(icon, { size: 'm' })}</ButtonIcon>

      {typeof children === 'string' ? (
        <FloraTypography as={'h6'} fontSize="subtitle" viewport={isMobile() ? 'mobile' : 'desktop'}>
          {children}
        </FloraTypography>
      ) : (
        children
      )}
    </DrawerHeader.Component>
  );
};

export default DrawerHeaderBase;
